import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "cn";
import { CheckIcon } from "lucide-react";
import type * as React from "react";

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      type="button"
      data-slot="checkbox"
      className={cn(
        /* sorted */
        "peer shrink-0",
        "size-5",
        "border-border-dark-high data-[state=checked]:bg-bg-primary data-[state=checked]:text-text-light data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive rounded-md border shadow-xs outline-hidden cursor-pointer",
        "transition-shadow",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3 text-current" strokeWidth={3} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
